import { atom } from 'jotai';
import { RemoteImageAlert_GetList_ResponseItem } from '~/common/typescript/apis/RemoteImageAlertAPIs';

export const landsatItemsLEFTAtom = atom<RemoteImageAlert_GetList_ResponseItem[]>([]);

export const landsatItemsRIGHTAtom = atom<RemoteImageAlert_GetList_ResponseItem[]>([]);

export const landsatLoadingAtom = atom<{ isLoading: boolean; text?: string }>({
  isLoading: false,
  text: '',
});

